export default "__VITE_ASSET__M9l9mn_C__"